import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-6">
      <div className="text-6xl font-bold text-vsw-500">404</div>
      <div className="text-vsw-300 text-lg">Page not found</div>
      <button
        onClick={() => navigate("/")}
        className="bg-vsw-500 text-white px-4 py-2 rounded font-medium hover:bg-vsw-400"
      >
        Back to Home
      </button>
    </div>
  );
}
